import { useRef, useState } from 'react';

import classNames from 'classnames';

import styles from './Menu.module.css';
import { MenuDropdown } from './MenuDropdown';
import { useOnClickOutside } from './useClickOutside';

export const Menu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const toggleMenu = () => setIsOpen(!isOpen);

  useOnClickOutside(menuRef, () => setIsOpen(false));

  return (
    <div className={styles.menuContainer} data-testid="navBarMenu">
      <div ref={menuRef}>
        <button
          data-testid="dropdown-menu"
          className={styles.rightAction}
          onClick={toggleMenu}
        >
          Menu
          <div
            className={classNames(styles.navIcon, isOpen && styles.closeIcon)}
          >
            <span className={styles.menuIconLine} />
            <span className={styles.menuIconLine} />
            <span className={styles.menuIconLine} />
            <span
              className={classNames(styles.menuIconLine, styles.animatedLine)}
            />
            <span
              className={classNames(styles.menuIconLine, styles.animatedLine)}
            />
          </div>
        </button>

        <MenuDropdown isOpen={isOpen} />
      </div>
    </div>
  );
};
